import React from 'react';
import { Map } from 'immutable';
import { ImageFromField, CoreLink } from '@uncinc/react-drupal-core';
import { BlobWrapper, WysiwygField } from '../../../../components';

import {
  SCREEN_MOBILE,
} from '../../../../config/constants';

import './style.scss';

const NodeColleagueParagraph = ({ entity }) => {
  return (
    <div className="NodeColleagueParagraph">
      <div className="row">
        <div className="col-md-6 col-lg-4">
          <div className="NodeColleagueParagraph__photo">
            <BlobWrapper>
              <ImageFromField
                field={entity.getIn(['field_hero', 0])}
                imageStyles={Map({
                  [SCREEN_MOBILE]: 'crop_standard',
                })}
                lazyload
              />
            </BlobWrapper>
          </div>

          <CoreLink to={entity.getIn(['paths', 'nl'])} title={entity.getIn(['field_name', 0, 'value'])} className="u-link-stretch h5">{entity.getIn(['field_name', 0, 'value'])}</CoreLink>
          <div className="NodeColleagueParagraph__job-title">{entity.getIn(['field_profession', 0, 'value'])}</div>
        </div>

        <div className="col-md-6 col-lg-8">
          <WysiwygField
            property="schema:text"
            html={entity.getIn(['body', 0, 'processed'], '')}
          />
        </div>
      </div>
    </div>
  );
};

export default NodeColleagueParagraph;
